import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Modal, ModalProps } from '/imports/ui/Modal';
import { Form } from '/imports/ui/Form';
import { toastOnError } from '/imports/ui/utils';
import { RichSelect } from '/imports/ui/RichSelect';
import { LoadingFill } from '/imports/ui/LoadingFill';
import { applyConsumptionMetersToProject, modelClass as projectModelClass, Project } from '/imports/api/projects';

const SendToProjectModalStyled = styled(Modal)`
  .modal-window {
    min-width: 28rem;
  }
  .instruction {
    margin-bottom: 1rem;
  }
  .modal-body {
    min-height: 12rem;
    position: relative;
    .buttons {
      margin-top: 1rem;
    }
  }
`;

interface SendToProjectModalProps {
  meterIds: string[];
  onClose: ModalProps['onClose'];
}

/** Modal that assigns selected consumption meters to a chosen project. */
export const SendToProjectModal = (props: SendToProjectModalProps) => {
  const { meterIds, onClose } = props;
  const [projectId, setProjectId] = useState<string>();
  const [running, setRunning] = useState(false);
  const submit = toastOnError(async () => {
    if (!projectId || !meterIds.length) return;
    setRunning(true);
    try {
      await applyConsumptionMetersToProject.call({ projectId, meterIds });
      toast.success(strings.Done());
      onClose?.();
    }
    finally {
      setRunning(false);
    }
  });
  return (
    <SendToProjectModalStyled
      title={strings.SendToProject()}
      onClose={running ? undefined : onClose}
    >
      <Form onSubmit={submit}>
        {
          running ?
            <LoadingFill />
            :
            <>
              <div className="instruction">{strings.SendToProjectInstruction()}</div>
              <RichSelect
                placeholder={strings.Project()}
                listMethod={projectModelClass.listMethod}
                listQuery={{ active: true }}
                mapToValue={(p: Project) => ({ value: p._id, label: p.name || p._id })}
                value={projectId}
                onChange={(option) => setProjectId(option.value)}
                fixedOptions={true}
              />
              <div className="buttons">
                <Button id="send-to-project-btn" type="submit" disabled={!projectId}>{strings.Submit()}</Button>
              </div>
            </>
        }
      </Form>
    </SendToProjectModalStyled>
  );
};
